import { MessageListDisplayModel } from '@administration/models/MessageList.display.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MessageService {
    constructor(private http: HttpClient) {}

    getMessageList(filter: MessageListDisplayModel): Observable<any> {
        return this.http.post<MessageListDisplayModel[]>('api:///Customs/GetMessageList', filter);
    }

    // getMessage(id: number): Observable<any> {
    //     return this.http.get<MessageDisplayModel>(`api:///Customs/GetMessage/${id}`);
    // }

    resendMessage(messageId: number): Observable<any> {
        return this.http.post(`api:///Customs/ResendMessage/${messageId}`, null);
    }

    resendMessages(messageIds: number[]): Observable<any> {
        return this.http.post('api:///Customs/ResendMessages', messageIds);
    }

    resendContainers(messageIds: number[]): Observable<any> {
        return this.http.post('api:///Customs/ResendContainers', messageIds);
    }
}
